import { get } from 'lodash';
import flowRight from 'lodash/flowRight';
import React from 'react';
import { connect } from 'react-redux';
import { recordAssignmentsOnMount } from '@zocdoc-frontend-common/utils-ab';
import {
    VARIANT_ON,
    PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP,
    PINATA_MFA_AUTH,
} from '@zocdoc-frontend-common/utils-ab/constants';
import { MetricsProvider, withCustomMetrics } from '@zocdoc/frontend-metrics';
import {
    trackClickFacebookLogin,
    trackClickGoogleLogin,
    trackClickAppleLogin,
    trackClickCreateAccount,
} from './SignInFormPatientProviderModeActions';
import { SignInFormPatientProviderModeView } from './SignInFormPatientProviderModeView';

const getPageId = () => get(window, 'ZD.configs.PAGE_ID');

export const mapStateToProps = (state) => {
    if (state.signInForm === undefined) {
        throw new Error(
            'Expected the sign in state to be available as `state.signInForm`. ' +
                "Ensure you have added the `signInReducer` to your store's reducers via `combineReducers`."
        );
    }

    return {
        isMfaEnabled: state.signInForm.isMfaEnabled,
        isUserLocked: state.signInForm.isUserLocked,
        rememberMe: state.signInForm.rememberMe,
        suggestedRedirect: state.signInForm.suggestedRedirect,
        isInEmailFirstLoginAndSignup:
            state.absystem?.[
                PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP.experimentId
            ] === VARIANT_ON,
    };
};

export const mapDispatchToProps = {
    onClickFacebookLogin: trackClickFacebookLogin,
    onClickGoogleLogin: trackClickGoogleLogin,
    onClickAppleLogin: trackClickAppleLogin,
    trackClickCreateAccount,
};

const SignInFormPatientProviderModeViewWithoutMetric = (props) => {
    return (
        <MetricsProvider getPageId={getPageId}>
            <SignInFormPatientProviderModeViewWithMetric {...props} />
        </MetricsProvider>
    );
};

const SignInFormPatientProviderModeViewWithMetric = withCustomMetrics({
    page: 'SignIn',
    zlogPageType: 'SignIn',
    zlogRollupBucket: 'Utility',
    component: 'SignInFormPatientProviderModeView',
})(SignInFormPatientProviderModeView);

export const SignInFormPatientProviderModeContainer = flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    recordAssignmentsOnMount([
        PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP,
        PINATA_MFA_AUTH,
    ])
)(SignInFormPatientProviderModeViewWithoutMetric);
